import { ReportType } from '@/types/report/types';
import { BaseApi } from '@/api/BaseApi';

/** Тип отчета */
export default class ReportTypeApi extends BaseApi<ReportType, ReportType> {
}
